"use client";
import IntlLangWrapper from "@/modules/i18n/components/IntlLangWrapper";
import DotsPattern from "../CSSPatterns/DotsPattern/DotsPattern";
import LinkButton from "../LinkButton/LinkButton";
import Image from "next/image";
import chatbotSample from "@/public/pictures/chatbot_sample.png";
import { scrollFx } from "@/modules/visual/scrollFx";
import { useTranslationHomePage } from "./home.hook";
import { calendlyUrl } from "@/modules/sales/sales.consts";
import PersonalizedDemoCTA from "@/modules/onboarding/components/PersonalizedDemoCTA";

export const SloganHeader = () => {
  const {
    headerSlogan,
    headerSlogan2,
    headerSloganCTA,
    headerSubSlogan,
    headerSubSlogan2,
    headerSloganCTAContactUs,
    headerSloganBadgeTitle,
    headerSloganBadgeText,
  } = useTranslationHomePage();

  return (
    <section className="overflow-hidden">
      <div
        className="max-w-[80%] mx-auto relative"
        {...scrollFx({ trigger: "middle", effect: "fade" })}
      >
        <DotsPattern />
        <div className="pt-32 pb-8 md:pt-32 md:pb-32 flex justify-center">
          <div className="text-center w-auto">
            <div className="mb-6 flex justify-center">
              <span
                className="
                inline-flex items-center gap-2 rounded-full
                bg-white/60 px-4 py-2 text-sm font-semibold text-slate-900
                ring-1 ring-indigo-200/60 backdrop-blur
                shadow-sm
                "
              >
                <span className="inline-flex items-center rounded-full bg-gradient-to-r from-indigo-600 to-blue-500 px-2 py-0.5 text-xs font-bold text-white">
                  {headerSloganBadgeTitle}
                </span>
                {headerSloganBadgeText}
              </span>
            </div>

            <h1 className="font-bold tracking-tight leading-[1.05] break-words hyphens-auto text-4xl sm:text-5xl lg:text-6xl">
              {headerSlogan2}
            </h1>

            <h2 className="mt-4 mx-auto max-w-2xl px-2 sm:px-0 leading-relaxed break-words text-base sm:text-lg md:text-xl">
              {headerSubSlogan2}
            </h2>
            <PersonalizedDemoCTA />
            <div className="py-3 flex justify-center md:flex-row flex-col">
              <div className="mx-3 z-50 my-3 md:my-0">
                <LinkButton href={calendlyUrl} isNewTab>
                  <span>{headerSloganCTAContactUs}</span>
                </LinkButton>
              </div>
              <DotsPattern right={120} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
